import React from 'react'

type Props = {
    group               : {
        groupId     : ID
        groupName   : string
        fields      : ID[]
    }
    addedColumnsIds?    : ID[]

    selected?           : boolean

    onSelectSection     : func
}

export default class MenuItem extends React.Component<Props> {

    onSelectSection = () => {
        this.props.onSelectSection(this.props.group.groupId)
    }

    render() {
        const counter = _.intersection(this.props.addedColumnsIds, this.props.group.fields).length

        return (
            <div className={Classes("item", {selected: this.props.selected})} onClick={this.onSelectSection}>
                <div className="row">
                    <div className="name">{this.props.group.groupName}</div>
                    {counter > 0 && <div className="counter">{counter}</div>}
                </div>
            </div>
        )
    }
}